<div class="main-content">
    <employee-tabs [parentRoute]="parentRoute"></employee-tabs>
    <div class="card">
        <div class="card-body">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>